// Configuration constants
export const POCKETBASE_URL = process.env.REACT_APP_POCKETBASE_URL || 'http://127.0.0.1:8090';

// API timeout configuration
export const API_TIMEOUT = parseInt(process.env.REACT_APP_API_TIMEOUT || '30000');

// Helper function to get file URL
export const getFileUrl = (collection: string, recordId: string, filename: string): string => {
  return `${POCKETBASE_URL}/api/files/${collection}/${recordId}/${filename}`;
};

// Helper function to get category image URL
export const getCategoryImageUrl = (categoryId: string, filename: string): string => {
  return getFileUrl('categories', categoryId, filename);
};

// Helper function to get product image URL
export const getProductImageUrl = (productId: string, filename: string): string => {
  return getFileUrl('products', productId, filename);
}; 